import React, { useState, useMemo } from 'react';
import { TICKET_PURCHASE_STRINGS } from './strings';
import styles from './TicketPurchaseModal.module.scss';

function getDiscountRate(originalPrice, realPrice) {
  if (!originalPrice || originalPrice <= realPrice) return 0;
  return Math.round((1 - realPrice / originalPrice) * 100);
}

function getTicketCount(product) {
  return parseInt(product.attributes?.count, 10) || 1;
}

function TicketPurchaseModal({
  isOpen = false,
  products = [],
  loading = false,
  onPurchase,
  onCancel,
  onClose,
}) {
  const [selectedIndex, setSelectedIndex] = useState(0);

  if (!isOpen || !products.length) return null;

  const selected = products[selectedIndex] || products[0];
  const count = getTicketCount(selected);
  const discount = getDiscountRate(selected.original_price, selected.price);
  const unitPrice = Math.round(selected.price / count);
  const totalPrice = selected.price;

  const formatPrice = (num) => Number(num).toLocaleString('ko-KR');

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget && e.isTrusted) onClose?.();
  };

  // 3개씩 row로 분할
  const rows = [];
  for (let i = 0; i < products.length; i += 3) {
    rows.push(products.slice(i, i + 3));
  }

  return (
    <>
      <div className={styles.overlay} onClick={handleOverlayClick} />
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modal}>

          <div className={styles.nav}>
            <span className={styles.badge}>{TICKET_PURCHASE_STRINGS.BADGE_LABEL_PURCHASE}</span>
            <button type="button" className={styles.closeBtn} onClick={onClose} aria-label="닫기">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M18 6L6 18M6 6l12 12" stroke="#171719" strokeWidth="1.5" strokeLinecap="round" />
              </svg>
            </button>
          </div>

          <div className={styles.header}>
            <h2 className={styles.title}>{TICKET_PURCHASE_STRINGS.PURCHASE_TITLE}</h2>
            <p className={styles.desc}>{TICKET_PURCHASE_STRINGS.PURCHASE_DESC}</p>
          </div>

          <div className={styles.quantitySection}>
            <span className={styles.quantityLabel}>
              {TICKET_PURCHASE_STRINGS.PURCHASE_QUANTITY_LABEL}
            </span>

            {rows.map((row, ri) => (
              <div key={ri} className={styles.quantityRow}>
                {row.map((product, ci) => {
                  const idx = ri * 3 + ci;
                  const cnt = getTicketCount(product);
                  const disc = getDiscountRate(product.original_price, product.price);
                  const isActive = selectedIndex === idx;

                  return (
                    <button
                      key={product.no}
                      type="button"
                      className={isActive ? styles.quantityBtnActive : styles.quantityBtn}
                      onClick={() => setSelectedIndex(idx)}
                    >
                      <span className={styles.quantityBtnCount}>{cnt}개</span>
                      {disc > 0 && (
                        <span className={styles.quantityBtnDiscount}>{disc}% 할인</span>
                      )}
                    </button>
                  );
                })}
              </div>
            ))}
          </div>

          <div className={styles.summarySection}>
            <div className={styles.summaryBox}>
              <div className={styles.summaryRow}>
                <span>{TICKET_PURCHASE_STRINGS.PURCHASE_PRICE_LABEL}</span>
                <div className={styles.summaryPriceRight}>
                  {discount > 0 && (
                    <span className={styles.discountBadge}>{discount}% 할인</span>
                  )}
                  <span>{formatPrice(unitPrice)}원 / {TICKET_PURCHASE_STRINGS.TICKET_UNIT}</span>
                </div>
              </div>
              <div className={styles.summaryRow}>
                <span>{TICKET_PURCHASE_STRINGS.PURCHASE_QTY_LABEL}</span>
                <span>{count}{TICKET_PURCHASE_STRINGS.TICKET_UNIT}</span>
              </div>
              <div className={styles.summaryDivider} />
              <div className={styles.summaryTotalRow}>
                <span>{TICKET_PURCHASE_STRINGS.PURCHASE_TOTAL_LABEL}</span>
                <span>{formatPrice(totalPrice)}원</span>
              </div>
            </div>
          </div>

          <div className={styles.actionArea}>
            <button type="button" className={styles.cancelButton} onClick={onCancel}>
              {TICKET_PURCHASE_STRINGS.CANCEL}
            </button>
            <button
              type="button"
              className={styles.purchaseButton}
              disabled={loading}
              onClick={() => onPurchase?.(selected)}
            >
              {loading ? '처리중...' : TICKET_PURCHASE_STRINGS.PURCHASE_BUTTON}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default TicketPurchaseModal;
